import React from 'react';
import PropTypes from 'prop-types';
import {GlossaryDispatch} from '../../Glossary';
import style from './style.module.scss';

/**
 * CategoryTabs:
 *  - Component lists the glossary Items in categories.
 */
export function CategoryTabs(props) {
  const categoryItem = (category, key) => (
    <CategoryTabItem key={key} {...category} />
  );
  return (
    <ul className={style.tabList}>{props.categories.map(categoryItem)}</ul>
  );
}

CategoryTabs.propTypes = {
  /**
   * List of Category Tabs
   */
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired,
    })
  ).isRequired,
};

CategoryTabs.defaultProps = {
  categories: [],
};

/**
 * CategoryTabItem:
 *  - Single Tab for Category list in Glossary component
 */
function CategoryTabItem(props) {
  const {onTabSelect} = React.useContext(GlossaryDispatch);

  const onClickTab = (event) => {
    event.preventDefault();
    onTabSelect(props.value);
  };

  const wrapperClass = () =>
    [style.tabList_item, props.selected ? style.active : ''].join(' ');

  return (
    <li
      onClick={onClickTab}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClickTab();
        }
      }}
      role="option"
      aria-selected={props.label}
      tabIndex={0}
      className={wrapperClass()}
    >
      {props.label}
    </li>
  );
}

CategoryTabItem.propTypes = {
  /**
   * Label for the tab Item
   */
  label: PropTypes.string.isRequired,
  /**
   * String value to uniquely identify the tab
   */
  value: PropTypes.string.isRequired,
  /**
   * Boolean specifying if the tab is selected
   */
  selected: PropTypes.bool.isRequired,
};

CategoryTabItem.defaultProps = {
  label: '',
  value: '',
  selected: false,
};
